import useLiveInfo from '@/hooks/useLiveInfo'
import styles from './index.module.sass'

const Benefit = ({ benefit }) => {
  const { serviceId } = useLiveInfo()
  if (!serviceId || serviceId === 'MYSHOP') {
    return <></>
  }

  const zeroPercent = '0%'
  const pointText = benefit ? benefit.reward.pointText : zeroPercent
  return (
    <span className={pointText === zeroPercent ? styles.pointsGrey : styles.points}>
      {pointText}
      {benefit?.reward.pointGuideText
        ? ` (${benefit?.reward.pointGuideText})`
        : <></>}
    </span>
  )
}

export default Benefit
